import { getQueryString, handleError } from "../apiUtils";
import axios from "../axios";

export async function searchOrganizations(query: object) {
  let searchQuery = getQueryString(query);
  try {
    const resp = await axios.get("/api/organization/search?" + searchQuery);
    return resp.data;
  } catch (error) {
    console.log(error);
    handleError(error);
  }
}

export async function getOrganizations() {
  try {
    const resp = await axios.get("/api/organization/?pageSize=1000");
    return resp.data;
  } catch (error) {
    console.log(error);
    handleError(error);
  }
}

export async function getOrganizationById(org_id: string) {
  try {
    const resp = await axios.get("/api/organization/" + org_id + "/details");
    return resp.data;
  } catch (error) {
    console.log(error);
    handleError(error);
  }
}

export async function createOrganization(organization: object) {
  try {
    const resp = await axios.put("/api/organization/create/", organization);
    return resp;
  } catch (error) {
    console.log(error);
    handleError(error);
  }
}

export async function updateOrganization(organization: object) {
  try {
    const resp = await axios.post("/api/organization/update/", organization);
    return resp;
  } catch (error) {
    console.log(error);
    handleError(error);
  }
}

export async function deleteOrganization(organization_id: string) {
  try {
    const resp = await axios.delete(
      "/api/organization/delete?id=" + organization_id
    );
    return resp;
  } catch (error) {
    console.log(error);
    handleError(error);
  }
}
